export default {
	Pay360: 1,
	Stripe: 2,
	HOPS: 10,
	HOPSOrderVoucher: 11,
	ThirdParty: 12
};
